module.exports = __webpack_public_path__ + "img/ios-long-picture.dab9a4a4.png";